import { useAtom } from "jotai"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Paths, RETURN_URL, SESSION_EXPIRED_KEY } from "../../common/commonConstants"
import { loginModalOpenAtom } from "../Menu/menu.store"
import { clearAuthData, isNewLoginUIEnabled, isProtectedRoute, isTokenValid } from "../Menu/menu.support"

export const TokenValidator = (): null => {
  const navigate = useNavigate()
  const location = useLocation()
  const [, setLoginModalOpen] = useAtom(loginModalOpenAtom)

  useEffect(() => {
    const currentPath = location.pathname

    if (currentPath === Paths.LOGIN.login || currentPath === Paths.LOGIN.logout) {
      return
    }

    if (!isTokenValid()) {
      if (isNewLoginUIEnabled()) {
        clearAuthData()
        if (isProtectedRoute(currentPath)) {
          sessionStorage.setItem(RETURN_URL, currentPath + window.location.search)
          navigate("/", { replace: true })
          setLoginModalOpen(true)
        }
        // On non-protected routes: just clear auth — login button reappears in header
      } else {
        if (isProtectedRoute(currentPath)) {
          const currentPathWithQuery = currentPath + window.location.search
          sessionStorage.setItem(RETURN_URL, currentPathWithQuery)
          sessionStorage.setItem(SESSION_EXPIRED_KEY, "true")
          navigate(Paths.LOGIN.login, { replace: true })
        }
      }
    }
  }, [location.pathname, navigate]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

